export default {
  titleBanner: {
    subtitle: 'TWR | Two-Way Ranging',
    title: 'Công nghệ định vị TWR',
    description: '*TWR (Two-Way Ranging) là một công nghệ định vị, đo khoảng cách bằng cách đo thời gian tín hiệu đi lại giữa thiết bị phát và thiết bị thu. <br/>',
  },
  definition: {
    title: 'TWR là gì?',
    text: `Khác với TDoA, trong đó nhiều anchor cố định cùng phối hợp để xác định vị trí của đối tượng di động, TWR chủ yếu sử dụng giao tiếp hai chiều giữa hai thiết bị. Ví dụ, có thể giám sát khoảng cách thời gian thực giữa các tag định vị gắn trên người, vật thể hoặc phương tiện. Nhờ đó, các ứng dụng dựa trên giao tiếp hai chiều như hệ thống cảnh báo va chạm tự động, phát hiện gần có thể được triển khai mà không cần hạ tầng bổ sung. <br/>Trong TWR, giao tiếp hai chiều giữa hai thiết bị, ví dụ như hai thẻ theo dõi vị trí, được sử dụng để giám sát khoảng cách giữa chúng theo thời gian thực. Do đó, các ứng dụng dựa trên giao tiếp hai chiều như hệ thống phát hiện va chạm tự động và phát hiện tiệm cận có thể được triển khai mà không cần cơ sở hạ tầng bổ sung.<br/>Trong TWR, khi hai thiết bị ở gần nhau, chúng sẽ bắt đầu quá trình "đo khoảng cách" (ranging) lẫn nhau để xác định cự ly. Sau đó, thời gian tín hiệu di chuyển sẽ được nhân với tốc độ ánh sáng để liên tục xác định vị trí tương đối. Điều này thường cho phép các dịch vụ và phương thức giao tiếp nhận biết vị trí. <br/><br/>Để đo khoảng cách, ba loại thông điệp cần được trao đổi:`,
    list: [
      `· Thiết bị đo khoảng cách như tag gửi thông điệp 'Poll' để khởi tạo TWR với các tag hoặc node RTLS gần đó.`,
      `· Thiết bị gần đó ghi lại thời điểm nhận được thông điệp 'Poll' và phản hồi bằng thông điệp 'Response'.`,
      `· Khi nhận được thông điệp 'Response', tag ghi lại thời gian nhận thông điệp này.`,
    ],
    text2: '<br/>Dựa trên thời gian nhận thông điệp cuối cùng, tag có thể tính ToF (Time of Flight – thời gian bay) và xác định khoảng cách giữa hai thiết bị.',
  },
  advantage: {
    title: 'Những ưu điểm chính của TWR',
    items: {
      realTime: {
        title: 'Real-Time',
        description: 'Công nghệ TWR cho phép các ứng dụng đo khoảng cách chính xác theo thời gian thực với độ trễ (latency) rất thấp (2-5 ms) và tốc độ cập nhật cao (lên đến 100Hz).',
      },
      twoWay: {
        title: 'Triển khai đa dạng các chức năng hai chiều Two-Way',
        description: 'Có thể cung cấp các chức năng đo khoảng cách như hệ thống tránh va chạm, cảm biến gần.',
      },
      flexible: {
        title: 'Linh hoạt',
        description: 'Không cần hạ tầng bổ sung, cung cấp các ứng dụng phạm vi P2P giữa hai thiết bị.',
      },
    },
  },
};
